// FlashCardQuizContent_v01.tsx
// External ReactNode quiz content object
// Version: v01

import { ReactNode } from "react";

export type FlashCardItem = {
  id: string;
  front: ReactNode;
  back: ReactNode;
  category?: string;
};

export type FlashCardTopic = {
  id: string;
  title: string;
  description: ReactNode;
  cards: FlashCardItem[];
};

export const flashCardTopics_v01: FlashCardTopic[] = [
  // {
  //   id: "spanish-basic",
  //   title: "Spanish Basics",
  //   description: <>Beginner Spanish words and phrases.</>,
  //   cards: [
  //     {
  //       id: "sp-001",
  //       front: <>How do you say <strong>Hello</strong> in Spanish?</>,
  //       back: <><strong>Hola</strong></>,
  //     },
  //     {
  //       id: "sp-002",
  //       front: <>How do you say <strong>Thank you</strong>?</>,
  //       back: <><strong>Gracias</strong></>,
  //     },
  //     {
  //       id: "sp-003",
  //       front: <>What does <strong>Buenos días</strong> mean?</>,
  //       back: <>Good morning</>,
  //     },
  //   ],
  // },

{
  id: "spanish-basic-expanded",
  title: "Spanish Basics – Top 20 Words",
  description: <>Beginner Spanish words with definitions, examples, and audio.</>,
  cards: [
    {
      id: "sp-001",
      front: <>How do you say <strong>Hello</strong> in Spanish?</>,
      back: <>
        <strong>Hola</strong><br/>
        Definition: Hello<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=hola&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Hola%2C%20%C2%BFc%C3%B3mo%20est%C3%A1s%3F%20Hola%20amigo.%20Hola%2C%20buenos%20d%C3%ADas.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Hola, ¿cómo estás?<br/>
        2. Hola amigo.<br/>
        3. Hola, buenos días.
      </>,
    },
    {
      id: "sp-002",
      front: <>How do you say <strong>Thank you</strong>?</>,
      back: <>
        <strong>Gracias</strong><br/>
        Definition: Thank you<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=gracias&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Gracias%20por%20tu%20ayuda.%20Muchas%20gracias.%20Gracias%2C%20se%C3%B1or.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Gracias por tu ayuda.<br/>
        2. Muchas gracias.<br/>
        3. Gracias, señor.
      </>,
    },
    {
      id: "sp-003",
      front: <>What does <strong>Buenos días</strong> mean?</>,
      back: <>
        <strong>Buenos días</strong><br/>
        Definition: Good morning<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=buenos%20dias&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Buenos%20d%C3%ADas%2C%20profesor.%20Te%20digo%20buenos%20d%C3%ADas.%20Buenos%20d%C3%ADas%20a%20todos.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Buenos días, profesor.<br/>
        2. Te digo buenos días.<br/>
        3. Buenos días a todos.
      </>,
    },
    {
      id: "sp-004",
      front: <>How do you say <strong>Goodbye</strong>?</>,
      back: <>
        <strong>Adiós</strong><br/>
        Definition: Goodbye<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=adios&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Adi%C3%B3s%2C%20nos%20vemos%20ma%C3%B1ana.%20Dijo%20adi%C3%B3s%20y%20sali%C3%B3.%20Adi%C3%B3s%20amigo.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Adiós, nos vemos mañana.<br/>
        2. Dijo adiós y salió.<br/>
        3. Adiós amigo.
      </>,
    },
    {
      id: "sp-005",
      front: <>How do you say <strong>Please</strong>?</>,
      back: <>
        <strong>Por favor</strong><br/>
        Definition: Please<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=por%20favor&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Pasa%20la%20sal%2C%20por%20favor.%20Ay%C3%BAdame%2C%20por%20favor.%20Ven%20aqu%C3%AD%2C%20por%20favor.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Pasa la sal, por favor.<br/>
        2. Ayúdame, por favor.<br/>
        3. Ven aquí, por favor.
      </>,
    },
    {
      id: "sp-006",
      front: <>How do you say <strong>Yes</strong>?</>,
      back: <>
        <strong>Sí</strong><br/>
        Definition: Yes<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=si&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=S%C3%AD%2C%20quiero.%20S%C3%AD%2C%20es%20correcto.%20S%C3%AD%2C%20vamos.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Sí, quiero.<br/>
        2. Sí, es correcto.<br/>
        3. Sí, vamos.
      </>,
    },
    {
      id: "sp-007",
      front: <>How do you say <strong>No</strong>?</>,
      back: <>
        <strong>No</strong><br/>
        Definition: No<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=no&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=No%20quiero.%20No%20es%20posible.%20No%20gracias.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. No quiero.<br/>
        2. No es posible.<br/>
        3. No gracias.
      </>,
    },
    {
      id: "sp-008",
      front: <>How do you say <strong>Sorry</strong>?</>,
      back: <>
        <strong>Perdón</strong><br/>
        Definition: Sorry / Excuse me<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=perdon&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Perd%C3%B3n%20por%20llegar%20tarde.%20Perd%C3%B3n%2C%20%C2%BFpuedo%20pasar%3F%20Perd%C3%B3n%2C%20fue%20mi%20error.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Perdón por llegar tarde.<br/>
        2. Perdón, ¿puedo pasar?<br/>
        3. Perdón, fue mi error.
      </>,
    },
    {
      id: "sp-009",
      front: <>How do you say <strong>Water</strong>?</>,
      back: <>
        <strong>Agua</strong><br/>
        Definition: Water<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=agua&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Quiero%20agua.%20El%20agua%20est%C3%A1%20fr%C3%ADa.%20Bebe%20m%C3%A1s%20agua.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Quiero agua.<br/>
        2. El agua está fría.<br/>
        3. Bebe más agua.
      </>,
    },
    {
      id: "sp-010",
      front: <>How do you say <strong>Food</strong>?</>,
      back: <>
        <strong>Comida</strong><br/>
        Definition: Food<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=comida&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=La%20comida%20est%C3%A1%20lista.%20Me%20gusta%20la%20comida%20mexicana.%20Necesitamos%20comida.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. La comida está lista.<br/>
        2. Me gusta la comida mexicana.<br/>
        3. Necesitamos comida.
      </>,
    },
    {
      id: "sp-011",
      front: <>How do you say <strong>Friend</strong>?</>,
      back: <>
        <strong>Amigo</strong><br/>
        Definition: Friend<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=amigo&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=%C3%89l%20es%20mi%20amigo.%20Hola%20amigo.%20Mi%20amigo%20vive%20aqu%C3%AD.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Él es mi amigo.<br/>
        2. Hola amigo.<br/>
        3. Mi amigo vive aquí.
      </>,
    },
    {
      id: "sp-012",
      front: <>How do you say <strong>House</strong>?</>,
      back: <>
        <strong>Casa</strong><br/>
        Definition: House<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=casa&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Mi%20casa%20es%20grande.%20Vamos%20a%20casa.%20La%20casa%20es%20bonita.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Mi casa es grande.<br/>
        2. Vamos a casa.<br/>
        3. La casa es bonita.
      </>,
    },
    {
      id: "sp-013",
      front: <>How do you say <strong>Car</strong>?</>,
      back: <>
        <strong>Coche</strong><br/>
        Definition: Car<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=coche&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=El%20coche%20es%20nuevo.%20Manejo%20mi%20coche.%20El%20coche%20est%C3%A1%20limpio.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. El coche es nuevo.<br/>
        2. Manejo mi coche.<br/>
        3. El coche está limpio.
      </>,
    },
    {
      id: "sp-014",
      front: <>How do you say <strong>Dog</strong>?</>,
      back: <>
        <strong>Perro</strong><br/>
        Definition: Dog<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=perro&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=El%20perro%20ladra.%20Mi%20perro%20es%20grande.%20El%20perro%20corre.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. El perro ladra.<br/>
        2. Mi perro es grande.<br/>
        3. El perro corre.
      </>,
    },
    {
      id: "sp-015",
      front: <>How do you say <strong>Cat</strong>?</>,
      back: <>
        <strong>Gato</strong><br/>
        Definition: Cat<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=gato&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=El%20gato%20duerme.%20Mi%20gato%20es%20negro.%20El%20gato%20juega.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. El gato duerme.<br/>
        2. Mi gato es negro.<br/>
        3. El gato juega.
      </>,
    },
    {
      id: "sp-016",
      front: <>How do you say <strong>Love</strong>?</>,
      back: <>
        <strong>Amor</strong><br/>
        Definition: Love<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=amor&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Te%20amo.%20El%20amor%20es%20fuerte.%20Siento%20amor%20por%20ti.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Te amo.<br/>
        2. El amor es fuerte.<br/>
        3. Siento amor por ti.
      </>,
    },
    {
      id: "sp-017",
      front: <>How do you say <strong>Good</strong>?</>,
      back: <>
        <strong>Bueno</strong><br/>
        Definition: Good<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=bueno&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Es%20bueno.%20Buen%20trabajo.%20La%20comida%20es%20buena.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Es bueno.<br/>
        2. Buen trabajo.<br/>
        3. La comida es buena.
      </>,
    },
    {
      id: "sp-018",
      front: <>How do you say <strong>Bad</strong>?</>,
      back: <>
        <strong>Malo</strong><br/>
        Definition: Bad<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=malo&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Es%20malo.%20Mal%20d%C3%ADa.%20El%20clima%20es%20malo.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Es malo.<br/>
        2. Mal día.<br/>
        3. El clima es malo.
      </>,
    },
    {
      id: "sp-019",
      front: <>How do you say <strong>Big</strong>?</>,
      back: <>
        <strong>Grande</strong><br/>
        Definition: Big<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=grande&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=La%20casa%20es%20grande.%20Un%20perro%20grande.%20Es%20muy%20grande.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. La casa es grande.<br/>
        2. Un perro grande.<br/>
        3. Es muy grande.
      </>,
    },
    {
      id: "sp-020",
      front: <>How do you say <strong>Small</strong>?</>,
      back: <>
        <strong>Pequeño</strong><br/>
        Definition: Small<br/><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=peque%C3%B1o&op=translate" target="_blank">Hear Word</a><br/>
        🔊 <a href="https://translate.google.com/?sl=es&tl=en&text=Un%20gato%20peque%C3%B1o.%20Es%20muy%20peque%C3%B1o.%20La%20casa%20es%20peque%C3%B1a.&op=translate" target="_blank">Hear Examples</a><br/><br/>
        1. Un gato pequeño.<br/>
        2. Es muy pequeño.<br/>
        3. La casa es pequeña.
      </>,
    },
  ],
},

  {
    id: "italian-basic",
    title: "Italian Basics",
    description: <>Beginner Italian words and phrases.</>,
    cards: [
      {
        id: "it-001",
        front: <>How do you say <strong>Hello</strong> in Italian?</>,
        back: <><strong>Ciao</strong></>,
      },
      {
        id: "it-002",
        front: <>How do you say <strong>Thank you</strong>?</>,
        back: <><strong>Grazie</strong></>,
      },
      {
        id: "it-003",
        front: <>What does <strong>Buongiorno</strong> mean?</>,
        back: <>Good morning</>,
      },
    ],
  },
  {
    id: "math-times-tables",
    title: "Math Times Tables",
    description: <>Practice multiplication facts.</>,
    cards: [
      {
        id: "math-001",
        front: <><strong>6 × 7</strong></>,
        back: <><strong>42</strong></>,
      },
      {
        id: "math-002",
        front: <><strong>8 × 9</strong></>,
        back: <><strong>72</strong></>,
      },
      {
        id: "math-003",
        front: <><strong>12 × 12</strong></>,
        back: <><strong>144</strong></>,
      },
    ],
  },
  {
    id: "part107-airspace",
    title: "Drone Part 107 — Airspace",
    description: <>FAA Part 107 airspace review questions.</>,
    cards: [
      {
        id: "p107-001",
        front: <>What airspace surrounds the busiest airports?</>,
        back: <><strong>Class B airspace</strong> surrounds the nation’s busiest airports.</>,
      },
      {
        id: "p107-002",
        front: <>What does Class C airspace generally require?</>,
        back: <>Two-way radio communication and ATC authorization before entry.</>,
      },
      {
        id: "p107-003",
        front: <>Can a remote pilot fly in controlled airspace without authorization?</>,
        back: <>No. Controlled airspace generally requires FAA/ATC authorization.</>,
      },
    ],
  },
];

// Add more topics by adding another object to flashCardTopics_v01.

// End of FlashCardQuizContent_v01.tsx
// Version: v01